import React from 'react';
import { Row, Col, Panel, Tag } from 'rsuite';
import { useTranslation } from 'react-i18next';

const Step1 = (props) => (
  <Panel
    shaded
    {...props}
    bordered
    header="Step 1"
    bodyFill
    style={{ display: 'inline-block', width: 340 }}
  >
    <img src="/kyc.png" height="240" />
    <Panel header={props.t('gettingStarted.kyc.heading')}>
      <p>
        <small>
          {props.t('gettingStarted.kyc.content')}{' '}
          <a href="https://example.com">link</a>.
        </small>
      </p>
    </Panel>
  </Panel>
);

const Step2 = (props) => (
  <Panel
    shaded
    {...props}
    bordered
    header="Step 2"
    bodyFill
    style={{ display: 'inline-block', width: 340 }}
  >
    <img src="/wallet.png" width="440" height="240" />
    <Panel header={props.t('gettingStarted.metamask.heading')}>
      <p>
        <small>
          {props.t('gettingStarted.metamask.content.1')}{' '}
          <a href="https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=enMetamask">
            metamask
          </a>{' '}
          {props.t('gettingStarted.metamask.content.2')}{' '}
          <a href="https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad?hl=en">
            Coinbase
          </a>{' '}
          {/* {props.t('gettingStarted.metamask.content.3')} */}
        </small>
      </p>
    </Panel>
  </Panel>
);

const Step3 = (props) => (
  <Panel
    shaded
    {...props}
    bordered
    header="Step 3"
    bodyFill
    style={{ display: 'inline-block', width: 340 }}
  >
    <img src="/matic.jpeg" width="340" height="240" />
    <Panel header={props.t('gettingStarted.matic.heading')}>
      <p>
        <small>{props.t('gettingStarted.matic.content')}</small>
      </p>
    </Panel>
  </Panel>
);

const HomeIntroSteps = () => {
  const { t } = useTranslation();
  return (
    <Row
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      className="show-grid"
    >
      <Col md={6} sm={12}>
        <Step1 t={t} />
      </Col>
      <Col md={6} sm={12}>
        <Step2 t={t} />
      </Col>
      <Col md={6} sm={12}>
        <Step3 t={t} />
      </Col>
    </Row>
  );
};

export default HomeIntroSteps;
